import {Construtor} from './construtor';

export class IndicadorProcesso implements Construtor<IndicadorProcesso> {

  public idIndicadorProcesso: number;
  public idIndicador: number;
  public idProcessoSetor: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (IndicadorProcesso)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdIndicadorProcesso(idIndicadorProcesso: any) {
    this.idIndicadorProcesso = idIndicadorProcesso;
  }

  set IdProcessoSetor(idProcessoSetor: any) {
    this.idProcessoSetor = idProcessoSetor;
  }

  set IdIndicador(idIndicador: any) {
    this.idIndicador = idIndicador;
  }

  parseFromJson(indicadorProcesso: any): void {
    this.idIndicadorProcesso = indicadorProcesso.idIndicadorProcesso;
    this.idProcessoSetor = indicadorProcesso.idProcessoSetor;
    this.idIndicador = indicadorProcesso.idIndicador;
  }

  copyObject(indicadorProcesso: IndicadorProcesso): void {
    this.idIndicadorProcesso = indicadorProcesso.idIndicadorProcesso;
    this.idProcessoSetor = indicadorProcesso.idProcessoSetor;
    this.idIndicador = indicadorProcesso.idIndicador;
  }

  modeloCompleto(): boolean {
    return this.idProcessoSetor !== undefined && this.idIndicador !== undefined;
  }

  getNewInstance(object?: any): IndicadorProcesso {
    return new IndicadorProcesso(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/indicador-processo.ts